export default __webpack_public_path__ + "static/media/Flat.d2edfbf3.png";